<template>
  <div class="container">
    <div class="content pd-font">
      <div
        class="row is-full"
        v-for="tier in Object.keys(partners)"
        :key="tier"
      >
        <div class="columns is-centered is-vcentered is-multiline">
          <div
            class="column is-one-third"
            v-for="partner in partners[tier]"
            :key="partner"
          >
            <PartnerLogo :data="partner" />
          </div>
        </div>
        <div
          v-if="tier == 'large' && partners[tier].length > 0"
          class="columns is-centered"
        >
          <div class="column is-one-third">
            <hr class="divider" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.divider {
  opacity: 0.2;
}
</style>

<script>
import PartnerLogo from "@/components/PartnerLogo";
import { partners } from "@/constants/partners";

export default {
  components: {
    PartnerLogo,
  },
  data() {
    const filterTier = (tier) => partners.filter((p) => p.tier === tier);
    return {
      partners: {
        large: filterTier("large"),
        medium: filterTier("medium"),
        small: filterTier("small"),
      },
    };
  },
};
</script>
